import {useQuery} from "@apollo/client";
import {GET_NOTIFICATIONS} from "../../store/queries/GetNotifications";
import {PopupNotification} from "./PopupNotification";
import React from "react";
import {GetUserNotificationsQuery, NotificationType} from "../../gql/graphql";

export const Notifications : React.FC = () => {
    const getNotifications = useQuery<GetUserNotificationsQuery>(GET_NOTIFICATIONS, {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true
    });
    
    return (
        <>
            {getNotifications.data?.userNotifications?.map((notification,index)=> {
                if(notification?.type == NotificationType.WebPopup){return(
                    <PopupNotification key={index} notification={notification}/>
                )}
            })}
           
        </>);
}